import { ChangeKindFilter } from '../../PendingChangesDrawer.constants';

import { PendingChangesSidebarTestIds } from './PendingChangesSidebar.testIds';

export const SIDEBAR_COUNTS_CONFIG = [
  {
    kind: ChangeKindFilter.DIRECT,
    tooltip: 'Direct changes',
    dataTestId: PendingChangesSidebarTestIds.DIRECT_COUNT,
  },
  {
    kind: ChangeKindFilter.RECALCULATED,
    tooltip: 'Recalculated values',
    dataTestId: PendingChangesSidebarTestIds.RECALCULATED_COUNT,
  },
];

export const EMPTY_COUNT_LABEL = '–';
